var redefine = require('./$.redefine');
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.redefine-all.js
 ** module id = 234
 ** module chunks = 0
 **/